import { EmailTypeService } from "@/services/emailType";
import { useQuery } from "@tanstack/react-query";

export const useEmailTypeQuery = (emailTypeId: string) => {
  const query = useQuery({
    queryKey: ["emailType", emailTypeId],
    queryFn: () => EmailTypeService.getType(emailTypeId),
    refetchOnWindowFocus: false,
  });

  return {
    query,
    emailType: query.data,
  };
};
